export const ADVERTISING_CONSENT_STORAGE_KEY = "garimpa:advertising-consent:v1";
export const ADVERTISING_CONSENT_CHANGE_EVENT = "garimpa:advertising-consent-changed";

export const ADVERTISING_CONSENT_CHOICES = ["granted", "denied"] as const;

export type AdvertisingConsentChoice = (typeof ADVERTISING_CONSENT_CHOICES)[number];
